module.exports = __webpack_public_path__ + "img/logo-jomazad.e41e229a.png";